export const getSurplusBeforeTax = (value) => {
  return {
    type: "GET_SURPLUS_BEFORE_TAX",
    payload: value,
  };
};

export const getTemplatePayrollTax = (value) => {
  return {
    type: "GET_TEMPLATE_PAYROLL_TAX",
    payload: value,
  };
};
export const getTemplatePayrollPercent = (value) => {
  return {
    type: "GET_TEMPLATE_PAYROLL_PERCENT",
    payload: value,
  };
};
export const getFixedEarnedIncome = (value) => {
  return {
    type: "GET_FIXED_EARNED_INCOME",
    payload: value,
  };
};

export const getStandardTaxRelief = (value) => {
  return {
    type: "GET_STANDARD_TAX_RELIEF",
    payload: value,
  };
};
export const getTaxableIncome = (value) => {
  return {
    type: "GET_TAXABLE_INCOME",
    payload: value,
  };
};
export const getLocalTaxes = (value) => {
  return {
    type: "GET_LOCAL_TAXES",
    payload: value,
  };
};
export const getLocalTaxesPercent = (value) => {
  return {
    type: "GET_LOCAL_TAXES_PERCENT",
    payload: value,
  };
};
export const getStateTax = (value) => {
  return {
    type: "GET_STATE_TAX",
    payload: value,
  };
};
export const getStateTaxCutOfValue = (value) => {
  return {
    type: "GET_STATE_TAX_CUT_OF_VALUE",
    payload: value,
  };
};
export const getStateTaxPercent = (value) => {
  return {
    type: "GET_STATE_TAX_PERCENT",
    payload: value,
  };
};
export const getPayrollTax = (value) => {
  return {
    type: "GET_PAYROLL_TAX",
    payload: value,
  };
};
export const getPayrollTaxPercent = (value) => {
  return {
    type: "GET_PAYROLL_TAX_PERCENT",
    payload: value,
  };
};
export const getGeneralPension = (value) => {
  return {
    type: "GET_GENERAL_PENSION",
    payload: value,
  };
};
export const getGeneralPensionCutOffValue = (value) => {
  return {
    type: "GET_GENERAL_PENSION_CUT_OFF_VALUE",
    payload: value,
  };
};
export const getGeneralPensionPercent = (value) => {
  return {
    type: "GET_GENERAL_PENSION_PERCENT",
    payload: value,
  };
};
export const getFuneralFees = (value) => {
  return {
    type: "GET_FUNERAL_FEES",
    payload: value,
  };
};
export const getFuneralFeesPercent = (value) => {
  return {
    type: "GET_FUNERAL_FEES_PERCENT",
    payload: value,
  };
};
export const getReductionOfGeneralPension = (value) => {
  return {
    type: "GET_REDUCTION_OF_GENERAL_PENSION",
    payload: value,
  };
};
export const getEarnedIncomeTax = (value) => {
  return {
    type: "GET_EARNED_INCOME_TAX",
    payload: value,
  };
};
export const getEarnedIncomeTaxCutOffValue = (value) => {
  return {
    type: "GET_EARNED_INCOME_TAX_CUT_OFF_VALUE",
    payload: value,
  };
};
export const getEarnedIncomeTaxPercent = (value) => {
  return {
    type: "GET_EARNED_INCOME_TAX_PERCENT",
    payload: value,
  };
};
export const getNetProfitPerYear = (value) => {
  return {
    type: "GET_NET_PROFIT_PER_YEAR",
    payload: value,
  };
};
export const getNetProfitPerMonth = (value) => {
  return {
    type: "GET_NET_PROFIT_PER_MONTH",
    payload: value,
  };
};
export const getGeneralPayrollTax = (value) => {
  return {
    type: "GET_GENERAL_PAYROLL_TAX",
    payload: value,
  };
};
export const getGeneralPayrollTaxPercent = (value) => {
  return {
    type: "GET_GENERAL_PAYROLL_TAX_PERCENT",
    payload: value,
  };
};
export const getGrossAnnualSalary = (value) => {
  return {
    type: "GET_GROSS_ANNUAL_SALARY",
    payload: value,
  };
};
export const getNonTaxableIncomeLimit = (value) => {
  return {
    type: "GET_NON_TAXABLE_INCOME_LIMIT",
    payload: value,
  };
};
